export default {
	//用户信息
	getUserInfo:'userInfo/get',//获取用户信息

    //登录
    mobileLogin:'login/password',//PC端手机号登录

    // 导出
    exportFileApi:'user/export/add',// 文件导出公共接口
    exportFilePage:'user/export/page',// 文件导出公共接口

	//菜单
	getUserMenu:'company/rbac/getUserMenu',//获取用户菜单 get

    // 资产评估
    getPropertyAssessmentList:'asset/eval/back/record/page',//

    //字典
    getDictionary:'dic/getDictionary',//字典
    getCodeByName:'company/dict/getCodeByName',//根据省市区名称换取省市区code

    // 供需服务 - 供应端
    supplyBackAudit:'supply/back/audit',//平台端-供需审核 POST
    supplyBackEditCount:'supply/back/edit/count',//平台端-编辑供需统计 POST
    supplyBackIntentionAudit:'supply/back/intention/audit',//平台端-意向审核 POST
    supplyBackIntentionDelete:'supply/back/intention/delete',//平台端-意向删除 POST
    supplyBackIntentionList:'supply/back/intention/list',//平台端-合作意向列表 POST
    supplyBackOffline:'supply/back/offline',//平台端-供需下线 POST
    supplyBackPage:'supply/back/page',//平台端-供需列表 POST
    intentionBackPage:'supply/back/intention/page',//平台端-合作意向分页列表 POST

    // 用户管理
    userPage:'/user/back/page',//平台端-用户列表

}